import { reservationActionTypes } from '@Actions/reservationActions';

const ReservationReducer = (state = {}, action) => {
  switch (action.type) {
    case reservationActionTypes.CREATE_RESERVATION.LOADING: {
      const { createReservationLoading } = action;
      return {
        ...state,
        createReservationLoading,
      };
    }
    case reservationActionTypes.GET_RESERVATION.LOADING: {
      const { getReservationLoading } = action;
      return {
        ...state,
        getReservationLoading,
      };
    }
    case reservationActionTypes.GET_RESERVATION.SUCCESS: {
      const { reservation, isReservationGroup } = action;
      if (isReservationGroup) {
        return {
          ...state,
          reservationGroup: reservation,
        };
      }
      return {
        ...state,
        reservation,
      };
    }
    case reservationActionTypes.UPDATE_FREE_RESERVATION.LOADING: {
      const { updateFreeReservationLoading } = action;
      return {
        ...state,
        updateFreeReservationLoading,
      };
    }
    default: {
      return state;
    }
  }
};

export default ReservationReducer;
